import { render, staticRenderFns } from "./LeadDeal.vue?vue&type=template&id=1ded995c&"
import script from "./LeadDeal.vue?vue&type=script&lang=js&"
export * from "./LeadDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports